import { ChevronRight, Mic } from 'lucide-react'
import { Link } from 'react-router'
import { Surface } from '@/components/ui/surface'
import { useInsprekenStatus } from './useInsprekenStatus'
import { previewOf, useOpenCaptures } from './useOpenCaptures'

/**
 * The entry on top of the Overzicht on a phone. It is only a link: it never constructs a
 * speech recogniser, that happens on the page behind it. Gone when Inspreken is off.
 */
export function InsprekenCard() {
  const { available } = useInsprekenStatus()
  const { captures } = useOpenCaptures(available)
  if (!available) return null
  const first = captures[0]
  return (
    <Surface asChild variant="page" padding="md">
      <Link to="/relaties/inspreken" className="flex min-h-11 items-center gap-3 md:hidden">
        <span className="grid size-11 shrink-0 place-items-center rounded-full bg-primary text-primary-foreground">
          <Mic aria-hidden className="size-5" />
        </span>
        <span className="min-w-0 flex-1">
          <span className="block text-base font-semibold">Inspreken</span>
          <span className="block text-sm text-muted-foreground">
            {first
              ? `${captures.length} openstaand · '${previewOf(first, 30)}'`
              : 'Spreek je verslag in; Sparky maakt er een gesprek, taken en afspraken van.'}
          </span>
        </span>
        <ChevronRight aria-hidden className="size-5 shrink-0 text-muted-foreground" />
      </Link>
    </Surface>
  )
}
